import { NewsCategory, NewsItem } from '../users/ChatNews';
import { INewsCardArticle, NEWS_CARD_CATEGORY_COLOR } from './ChatNewsCard';

interface CategoryStyle {
  label: string;
  color: string;
}

const CATEGORY_MAP: Record<NewsCategory, CategoryStyle> = {
  industry_adoption: { label: '산업 / 도입사례', color: NEWS_CARD_CATEGORY_COLOR.industryAdoption },
  bigtech_tech: { label: '빅테크 / 신기술', color: NEWS_CARD_CATEGORY_COLOR.bigTechTrend },
  governance_risk: { label: '보안 / 리스크', color: NEWS_CARD_CATEGORY_COLOR.securityRisk },
};

const DEFAULT_CATEGORY = { label: 'IT 트렌드', color: NEWS_CARD_CATEGORY_COLOR.industryAdoption };

const CATEGORY_LOOKUP: Partial<Record<string, CategoryStyle>> = CATEGORY_MAP;

const toCategory = (category: string): CategoryStyle => {
  if (!category) return DEFAULT_CATEGORY;
  const key = category.trim().toLowerCase().replace(/-/g, '_');
  return CATEGORY_LOOKUP[key] ?? DEFAULT_CATEGORY;
};

const KST_OFFSET_MS = 9 * 60 * 60 * 1000;

const toDisplayDate = (value: string | null): string => {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date.getTime())) return '';

  const kst = new Date(date.getTime() + KST_OFFSET_MS);
  const y = kst.getUTCFullYear();
  const m = `${kst.getUTCMonth() + 1}`.padStart(2, '0');
  const d = `${kst.getUTCDate()}`.padStart(2, '0');
  return `${y}.${m}.${d}`;
};

export const toNewsCardArticle = (item: NewsItem): INewsCardArticle => ({
  id: item.id,
  category: toCategory(item.category),
  title: item.displayTitle,
  description: item.detailTitle,
  source: {
    name: item.sourceName,
    date: toDisplayDate(item.publishedAt),
  },
  imageUrl: item.imageUrl ?? '',
  bodyParagraphs: item.summaryParagraphs,
  reference: {
    label: '출처',
    text: item.sourceTitle || item.sourceName,
    url: item.sourceUrl || undefined,
  },
  insight: item.ktdsInsight?.text ? { label: '인사이트', content: item.ktdsInsight.text } : undefined,
});

export const toNewsCardArticles = (items: NewsItem[]): INewsCardArticle[] => items.map(toNewsCardArticle);
